import { Injectable } from '@angular/core';
import { of } from 'rxjs/observable/of';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class StateService {
  token: string;
  authStatus = false;
  account = null;
  callList;
  private products = [];
  prodService = new BehaviorSubject(this.products);
  private services = [];
  servService = new BehaviorSubject(this.services);
  private currentDriverServiceSource = new BehaviorSubject<number>(0);
  currentDriverService = this.currentDriverServiceSource.asObservable();
  private currentVehicleServiceSource = new BehaviorSubject<number>(0);
  currentVehicleService = this.currentVehicleServiceSource.asObservable();
  private isQueryEmptySource = new BehaviorSubject<boolean>(false);
  isQueryEmpty = this.isQueryEmptySource.asObservable();
  private driversVehiclesLengthSource = new BehaviorSubject<number>(0);
  driversVehiclesLength = this.driversVehiclesLengthSource.asObservable();
  private carSaveEventSource = new BehaviorSubject<boolean>(false);
  carSaveEvent = this.carSaveEventSource.asObservable();
  private saveVehicleSource = new BehaviorSubject<number>(0);
  saveVehicle = this.saveVehicleSource.asObservable();
  permisions = [];
  permissions$ = new BehaviorSubject([]);
  whoAmI;

  constructor() {}

  emittSaveVehicle(value: number) {
    return this.saveVehicleSource.next(value);
  }

  emittCarSaveEvent(isClick: boolean) {
    return this.carSaveEventSource.next(isClick);
  }

  emittDriversVehicleslength(length: number) {
    return this.driversVehiclesLengthSource.next(length);
  }

  emittIsQueryEmpty(value: boolean) {
    return this.isQueryEmptySource.next(value);
  }

  emittCurrentVehicleService(id: number) {
    return this.currentVehicleServiceSource.next(id);
  }

  emittCurrentDriverService(id: number) {
    return this.currentDriverServiceSource.next(id);
  }

  setParameter(param: string, item): void {
    if (param == 'services') {
      this.services = item;
      this.prodService.next(this.services);
    } else if (param == 'products') {
      this.products = item;
      this.servService.next(this.products);
    }
    this[param] = item;
  }

  getParameter(param: string): any {
    if (param === 'products' || param === 'services' || param === 'permisions') {
      return of(this[param]);
    } else {
      return this[param];
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/state.service.ts